import { RequestType } from './_types';
import { pipe } from './tools/pipe';
import { path } from './internal/path';
import { type } from './internal/type';
export const ping = pipe(path('/ping'), type(RequestType.Ping));
